import GameStepBase, {createGameFlowCancelResponse} from "./game_step_base";
import Event from "../../../utils/event";
import {SYSTEM_EVENTS} from "../../../events/events";
import {GAMES_INFO, ILocalizedGameInfo} from "../../games_information/games_information_service_interface";
import {IOpenSessionDetails} from "../../open_sessions/open_sessions_service_interface";
import {TRIPLE_EIGHT_COMPANY_NAME} from "../../company_selector/companies/888/888_const";


export default class BonusAbusePreventionGameStep extends GameStepBase {
    static CLASS = 'BonusAbusePreventionGameStep';

    run(gameOptions) {
        if(gameOptions.freePlayData) {
            return Promise.resolve(gameOptions);
        }
        return this._runBonusAbusePreventionGameStep(gameOptions);
    }

    private async _runBonusAbusePreventionGameStep(gameOptions): Promise<any> {
        let filteredOpenSessions: ILocalizedGameInfo[] = [];
        try {
            const openSessions: IOpenSessionDetails[] = await this.serviceFactory.openSessionsService().getAllGamesOpenSessions();
            filteredOpenSessions = await this._filterOpenSessionsByGameGroup(openSessions);
            if (filteredOpenSessions.length === 0 || this._isDisconnectedGame(gameOptions.gameInfo.gameType, filteredOpenSessions)) {
                return gameOptions;
            }
        } catch (err) {
            this._sendAnalytics( 'Error', JSON.stringify(err));
            return gameOptions;
        }
        this._sendAnalytics( 'Show', gameOptions.gameInfo.gameType.toString());
        await this._showBonusAbusePreventionMessage(filteredOpenSessions[0], gameOptions);
    }

    private _showBonusAbusePreventionMessage(disconnectedGame:ILocalizedGameInfo, gameOptions: any): Promise<void>{
        return new Promise( (resolve, reject) => {
            this.serviceFactory.messageManagerService().openMessage({
                closeButton: false,
                title: this.serviceFactory.languageService().translation('bonus_abuse_prevention_title'),
                text: this.serviceFactory.languageService().translation('bonus_abuse_prevention_message', {
                    gameName: disconnectedGame.title,
                    newGameName: gameOptions.gameInfo.title
                }),
                buttons: [
                    {
                        name: this.serviceFactory.languageService().translation('bonus_abuse_prevention_complete_btn'),
                        type: 'main',
                        isClosable: true,
                        callback: () => {
                            reject(createGameFlowCancelResponse('Complete disconnected game'));
                            Event.once(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, (status)=> {
                                if(status === false) {
                                    this.serviceFactory.gameService().openRealGame(disconnectedGame);
                                }
                            }, this);
                            this._sendAnalytics( 'Click_Complete_Game', disconnectedGame.gameType.toString());
                        }
                    },
                    {
                        name: this.serviceFactory.languageService().translation('bonus_abuse_prevention_notnow_btn'),
                        type: 'secondary',
                        isClosable: true,
                        callback: () => {
                            this._sendAnalytics('Click_Not_Now', gameOptions.gameInfo.gameType.toString());
                            reject(createGameFlowCancelResponse('Player has disconnected game'));
                        }
                    }
                ]
            });
        })
    }

    private async _filterOpenSessionsByGameGroup(openSessions: IOpenSessionDetails[]): Promise<ILocalizedGameInfo[]> {
        const gameTypes = openSessions.map(openSession => openSession.GameTypeID);
        const filteredOpenSessions:ILocalizedGameInfo[] = [];
        const allowedGamesInLayout = await this.serviceFactory.integrationService().filterInLayoutGames(gameTypes);
        const gamesInfo: GAMES_INFO = await this.serviceFactory.gamesInformationService().getGamesInfo(allowedGamesInLayout);
        openSessions.forEach(openSession => {
            const gameInfo = gamesInfo[openSession.GameTypeID];
            if (gameInfo?.companyName === TRIPLE_EIGHT_COMPANY_NAME){
                if (this.serviceFactory.gamesInformationService().isRouletteOrBlackjackOrBaccarat(gameInfo.gameGroupId)) {
                    filteredOpenSessions.push(gamesInfo[openSession.GameTypeID]);
                }
            }
        });

        return filteredOpenSessions;
    }

    private _isDisconnectedGame(gameType:number, filteredGames: ILocalizedGameInfo[]):boolean{
        let result = false;
        filteredGames.forEach( game => {
           if (game.gameType === gameType) {
               result = true;
           }
        });
        return result;
    }

    private _sendAnalytics(label:string, value:string) {
        const analyticObject = {
            category: 'Communications',
            action: 'Open_Session',
            label: 'Open_Session_' + label,
            value: value
        };
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObject);
    }
}